import styled from "styled-components";
import Color from "../assets/Colors";

export const ContentContainer = styled.div`
   width: 105.2%;
   margin-left: -2.6%;
   display: flex;
   flex-wrap: wrap;
   justify-content: center;

   background-position: center;
   background-size: cover;
   background-repeat: no-repeat;

   &.first {
      padding-top: 1em;
   }

   @media screen and (max-width: 1600px) {
      margin-left: 107%;
      margin-left: -3.5%;
   }

   @media screen and (max-width: 1400px) {
      width: 104.5%;
      margin-left: calc(-4.5% / 2);
   }

   @media screen and (max-width: 500px) {
      background-position: center right;

      width: 110%;
      margin-left: -5%;
   }
`;

export const TypeTitle = styled.p`
   margin: 0;
   font-size: ${(props) => props.size || "1.2em"};
   text-transform: uppercase;
   font-weight: 200;
   color: ${(props) => props.color || Color.textColor};

   &.principalTitle,
   &.principal {
      font-size: 1em;
   }
   &.titleSection {
      font-size: 1.6em;
   }

   @media screen and (max-width: 1600px) {
      font-size: 1.33em;

      &.principalTitle,
      &.principal {
         font-size: 0.9em;
      }
      &.titleSection {
         font-size: 1.2em;
      }
      &.facilitadorName {
         font-size: 1em !important;
         margin-bottom: 0.5em !important;
      }
   }

   @media screen and (max-width: 800px) {
      font-size: 1em;

      &.principalTitle,
      &.principal {
         font-size: 0.8em;
      }
      &.titleSection {
         font-size: 1.2em;
      }
      &.facilitadorName {
         font-size: 1em !important;
         margin-bottom: 0.5em !important;
      }
   }

   @media screen and (max-width: 500px) {
      &.principalTitle {
         font-size: 1em;
      }
   }
`;

export const NameTitle = styled.p`
   color: ${(props) => props.color || Color.primary};
   font-size: 1.6em;
   font-weight: ${(props) => props.weight || "600"};
   margin: 0.5em 0 0 0;
   user-select: none;

   @media screen and (max-width: 1600px) {
      font-size: 1em;
   }

   @media screen and (max-width: 800px) {
      margin: 0.2em 0 0 0;
      font-size: 0.8em;
   }

   @media screen and (max-width: 500px) {
      &.none {
         display: none;
      }
      font-size: 0.91em;
   }
`;

export const TextDescription = styled.p`
   display: block;
   display: -webkit-box;
   color: ${Color.textColor};
   font-size: 1.4em;
   margin: 0;
   font-weight: 200;
   line-height: 1.4;
   -webkit-line-clamp: 4;
   -webkit-box-orient: vertical;
   text-overflow: ellipsis;
   -webkit-max-lines: 4;
   height: calc(4 * 1.4em * 1);
   overflow: hidden;

   @media screen and (max-width: 1600px) {
      font-size: 0.85em;
      height: calc(4 * 0.9em * 1.4);
   }

   @media screen and (max-width: 1400px) {
      font-size: 0.8em;
      height: calc(4 * 0.9em * 1.5);
   }

   @media screen and (max-width: 800px) {
      font-size: 0.86em;
   }
   @media screen and (max-width: 500px) {
      font-size: 0.86em;
      height: calc(4 * 0.86em * 1.5);
   }
`;

export const TextDescriptionView = styled.p`
   color: ${Color.textColor};
   font-size: 1.6em;
   margin: 0;
   font-weight: 200;
   line-height: 1.4em;

   &.viewDescription {
      font-size: 1.6em;

      @media screen and (max-width: 1600px) {
         font-size: 1.2em;
      }

      @media screen and (max-width: 500px) {
         font-size: 0.9em;
         margin-bottom: 1em;
      }
   }
`;

export const IconClass = styled.div`
   position: relative;

   & img {
      position: absolute;
      top: -4em;
      width: 4em;
      height: 4em;
   }

   @media screen and (max-width: 1600px) {
      & img {
         top: -3em;
         width: 3em;
         height: 3em;
      }
   }

   @media screen and (max-width: 1400px) {
      & img {
         top: -2.3em;
         width: 2.5em;
         height: 2.5em;
      }
   }

   @media screen and (max-width: 500px) {
      & img {
         top: -2.5em;
      }
   }
`;
